import React from 'react';

const Home = () => {

  return (
    <main className='mx-auto p-4'>
      <h3><b>Admin DashBoard</b></h3>
      <div className='bg-[#134463] text-white p-4 rounded-lg mt-2'>
        <h2>Welcome Back</h2>
        <p>To get started use the navigation on your left.</p>
      </div>
    </main>
  );
};

export default Home;
